import { Button } from "primereact/button";
import React, { useState, useEffect, useRef, useCallback } from "react";
import "./styles.css";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";

const BannerCarousel = ({ items = [] }) => {
  // Máximo de 3 items
  const bannerItems = items.slice(0, 3);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const autoPlayRef = useRef(null);

  // Slide anterior
  const handlePrev = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? bannerItems.length - 1 : prevIndex - 1));

    setTimeout(() => setIsTransitioning(false), 500);
  };

  // Callback para navegar para o slide seguinte
  const handleNext = useCallback(() => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => (prevIndex === bannerItems.length - 1 ? 0 : prevIndex + 1));

    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning, bannerItems, setIsTransitioning, setCurrentIndex]);

  // Eventos touch
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swiped left
      handleNext();
    }

    if (touchStart - touchEnd < -50) {
      // Swiped right
      handlePrev();
    }
  };

  // Auto play
  useEffect(() => {
    const play = () => {
      autoPlayRef.current = setTimeout(() => {
        handleNext();
      }, 10000); // 10 seconds
    };

    play();
    return () => {
      if (autoPlayRef.current) {
        clearTimeout(autoPlayRef.current);
      }
    };
  }, [currentIndex, handleNext]);

  const generateImageUrl = (item) => {
    if (item?.cloudinary)
      return cloudinaryInstance.image(item.bgImg).resize(fill().width(1200).height(400)).toURL();

    return item.bgImg;
  };

  return (
    <div className="relative w-full overflow-hidden">
      {/*Container */}
      <div
        className="relative primary-banner-responsive"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Carousel items */}
        {bannerItems.map((item, index) => (
          <div
            key={item.id}
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center transition-transform transition-duration-500 transition-ease-in-out ${
              index === currentIndex
                ? "translate-x-0"
                : index < currentIndex
                ? "-translate-x-100"
                : "translate-x-100"
            }`}
            style={{
              backgroundImage: `url(${generateImageUrl(item)})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
        ))}
      </div>

      {/* Navegação */}
      <Button
        style={{ top: "50%", left: "2rem", transform: "translateY(-50%)", zIndex: 1 }}
        className="absolute bg-transparent border-none p-no-outline"
        icon="pi pi-chevron-left"
        onClick={handlePrev}
        aria-label="Previous slide"
      ></Button>

      <Button
        style={{ top: "50%", right: "2rem", transform: "translateY(-50%)", zIndex: 1 }}
        className="absolute bg-transparent border-none p-no-outline"
        icon="pi pi-chevron-right"
        onClick={handleNext}
        aria-label="Next slide"
      ></Button>
    </div>
  );
};

export default BannerCarousel;
